import React, { Fragment, useContext, useEffect, useState } from "react";
import { toast, Zoom } from "react-toastify";
import { Container } from "reactstrap";
import Breadcrumbs from "../../layout/breadcrumb";
import OrderStatusAddModal from "./orderStatusAddModal";
import OrderStatusMasterItem from "./orderStatusMasterItem";
import {
  OrderStatusAdd,
  OrderStatusDetails,
  OrderStatusEdit,
  OrderStatusList,
} from "../../api/Order Status Order Api/OrderStatusApi";
import OrderMasterContext from "../../context/OrderMasterContext/OrderMasterContext";
import TopLoadingBar from "../topLoadingBar/topLoadingBar";
import { ORDER_STATUS_MASTER } from "../../constant";
import LoaderContext from "../../context/LoaderContext/LoaderContext";
import { tableId } from "../../utils/helper";
import { useNavigate } from "react-router";
import SocketContext from "../../context/SocketContext/SocketContext";
import { userLogout } from "../../auth/Logout";

const OrderStatusMaster = () => {
  const {
    setorderValue,
    statusName,
    setStatusName,
    orderStatusId,
    setorderStatusID,
    setModal,
    modal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    editIndex,
    seteditIndex,
    progress,
    setProgress,
    toggleSubmit,
    setToggleSubmit,
    orderValue,
  } = useContext(OrderMasterContext);
  const history = useNavigate();
  const { socket } = useContext(SocketContext);
  const { loaderShow, setLoaderShow } = useContext(LoaderContext);

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);

  /**
   * order status list function call
   */

  const getData = async () => {
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy,
      };
      const { data } = await OrderStatusList(paramsObj);
      if (data.status === 200) {
        setorderValue(data.payload.data);
        setRecord(data.pager.totalRecords);
      } else {
        setorderValue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };
  useEffect(() => {
    getData();
    setProgress(100);
  }, [page, pageSize, sortOrder, sortBy]);

  tableId(page, pageSize, orderValue);

  /**
   * Push button click to addmodel function call
   */

  const AddModel = () => {
    setModal(true);
    setToggleSubmit(true);
  };

  /**
   * edit status function call
   */

  const editHandle = async (orderStatusId) => {
    setorderStatusID(orderStatusId);
    setLoaderShow(!loaderShow);
    try {
      const { data } = await OrderStatusDetails(orderStatusId);
      if (data.status === 200) {
        setToggleSubmit(false);
        seteditIndex(orderStatusId);
        setModal(true);
        getData();
        setStatusName(data.payload.data.statusName);
        setLoaderShow(false);
      }
    } catch (error) {
      setLoaderShow(false);
      if (error?.response?.data?.status === 401) {
        userLogout(history, socket);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * empty feild function call
   */

  const emptyFeild = () => {
    setStatusName("");
    setorderStatusID("");
    setLoaderShow(false);
  };

  /**
   * fill feils function call
   */

  const fillFeild = () => {
    setStatusName(statusName);
    setorderStatusID(orderStatusId);
    setLoaderShow(false);
  };

  /**
   * create and edit to function call
   */

  const onSubmit = async (e) => {
    e.preventDefault();
    let formData;

    if (editIndex > -1 && !toggleSubmit) {
      setLoaderShow(!loaderShow);
      formData = {
        statusName: statusName,
        orderStatusId: orderStatusId,
      };

      try {
        const { data } = await OrderStatusEdit(formData, orderStatusId);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
          });
          setModal(false);
          getData();
          emptyFeild();
        } else {
          fillFeild();
        }
      } catch (error) {
        setLoaderShow(false);
        if (error?.response?.data?.status === 401) {
          userLogout(history, socket);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } else {
      setLoaderShow(!loaderShow);
      formData = {
        statusName: statusName,
      };
      try {
        const { data } = await OrderStatusAdd(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
          });
          setModal(false);
          getData();
          emptyFeild();
        } else {
          fillFeild();
        }
      } catch (error) {
        setLoaderShow(false);
        if (error?.response?.data?.status === 401) {
          userLogout(history, socket);
        }
        toast.error(error?.response?.data?.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    }
  };

  /**
   * sorting function call
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  /**
   * close model to funcrion call
   */

  const closeModel = () => {
    emptyFeild();
    setModal(!modal);
  };

  return (
    <Fragment>
      <Breadcrumbs parent={ORDER_STATUS_MASTER.PERENT} />
      <TopLoadingBar progress={progress} setProgress={setProgress} />
      <Container fluid={true}>
        <OrderStatusAddModal onSubmit={onSubmit} closeModel={closeModel} />

        <OrderStatusMasterItem
          editHandle={editHandle}
          sorting={sorting}
          AddModel={AddModel}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
        />
      </Container>
    </Fragment>
  );
};

export default OrderStatusMaster;
